import { Center } from "@chakra-ui/react";
import BearRedirect from "components/BearRedirect";
import Header from "components/Header";
import Layout from "components/Layout";
import NotFoundMessage from "components/NotFoundMessage";
import WalletErrors from "components/WalletErrors";
import BearDetailsPage from "pages/BearDetailsPage";
import BearsListPage from "pages/BearsListPage";
import { Fragment } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

const bearRoutes = [
  {
    path: "/bears",
    component: BearDetailsPage,
  },
];

const ConnectedPage = () => (
  <Layout>
    <Header />

    <Routes>
      <Route path="/" element={<Navigate to="/bears" replace />} />

      <Route path="/bears" element={<BearsListPage />} />

      {bearRoutes.map(({ path, component: Component }) => (
        <Fragment key={path}>
          <Route path={path} element={<BearRedirect basePath={path} />} />
          <Route path={`${path}/:tokenId`} element={<Component />} />
        </Fragment>
      ))}

      <Route
        path="*"
        element={
          <Center pt="12" pb="16">
            <NotFoundMessage />
          </Center>
        }
      />
    </Routes>

    <WalletErrors />
  </Layout>
);

export default ConnectedPage;
